// GLOBAL FUNCTIONS

// Get URL Query
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
	const results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// Throttle
const _throttle = (cb, delay = 250) => {
  let shouldWait = false
  return (...args) => {
    if (shouldWait) return
    cb(...args)
    shouldWait = true
    setTimeout(() => {
      shouldWait = false
    }, delay)
  }
}

// Debounce
function _debounce(func, timeout = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

// Klaviyo Subscribe
function klaviyoSubscribe(kl_list_id, kl_email, kl_signup_source, consentGiven, consentType, birthday) {
	var _learnq = _learnq || [];
	_learnq.push(['identify', { $email: kl_email }]);
	const xhr = new XMLHttpRequest();
	const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
	const params = consentGiven
		? `g=${kl_list_id}&email=${encodeURIComponent(
				kl_email
		  )}&$fields=$source,$consent&$source=${kl_signup_source}&$consent=${consentType}`
		: `g=${kl_list_id}&email=${encodeURIComponent(kl_email)}&$fields=$source,Birthday&$source=${kl_signup_source}&Birthday=${birthday}`;
	xhr.open('POST', url, true);
	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhr.setRequestHeader('cache-control', 'no-cache');
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4 && xhr.status === 200) {
			console.log(xhr.responseText);
		}
	};
	xhr.send(params);
};

// Header CSS variables
function setHeaderVariables() {
  document.documentElement.style.setProperty('--header-height', `${document.querySelector('header').offsetHeight}px`);
}

// Check open cart

if (getUrlParameter('view_cart') == 'true') {
  Cart.openCart();
}

// Dialogs

const dialog = document.querySelector('[data-dialog]');
const dialogs = document.querySelectorAll('[data-dialog]');
const dialogOverlay = document.querySelectorAll('[data-dialog-overlay]');

function showDialog(name, dialogName) {
	if (!name) {
		console.error('Missing "name" attribute for showDialog()');
	}
	if (dialogName) {
		const customDialog = document.querySelector(`[data-dialog="${dialogName}"]`);
		customDialog.className = `dialog active ${name}`;
		customDialog.querySelector('[data-dialog-wrapper]').focus();
	} else {
		dialog.className = `dialog active ${name}`;
		dialog.querySelector('[data-dialog-wrapper]').focus();
	}
}

function hideDialog() {
	dialogs.forEach((dialog) => (dialog.className = 'dialog'));
}

dialogOverlay.forEach((el) => {
  el.addEventListener('click', () => {
    hideDialog();
  });
});

document.addEventListener('click', event => {
  if (event.target.hasAttribute('data-close-dialog')) {
    hideDialog();
  }
});

// Search
const searchBtn = document.querySelectorAll('[data-search-btn]');
const searchDropdown = document.querySelector('[data-search]');
const searchInput = document.querySelector('#searchInput');

if (searchBtn) {
  searchBtn.forEach(button => button.addEventListener('click', event => {
    Array.from(event.target.children).forEach(svg => svg.classList.toggle('hidden'));
    searchDropdown.classList.toggle('active');
    setTimeout(function () {
      searchInput.focus();
    }, 150);
  }));
}

// Set header height variable for position sticky elements
document.addEventListener('DOMContentLoaded', function (event) {
  setHeaderVariables();
});

// Escape handler
document.addEventListener('keydown', (event) => {
  if (event.code === 'Escape') {
    hideDialog();
  }
});

// Smooth scroll
document.querySelectorAll('[data-scroll-btn]').forEach((button) => {
  button.addEventListener('click', function () {
    const target = this.dataset.scrollBtn;
    const scrollTarget = document.querySelector(`[data-scroll-target="${target}"]`);
    const offset = parseInt(scrollTarget.dataset.scrollOffset) || 0;
    const distance =
      window.pageYOffset + scrollTarget.getBoundingClientRect().top;
    const headerHeight = document.querySelector('header').offsetHeight;
    window.scroll({
      top: distance - headerHeight - offset,
      left: 0,
      behavior: 'smooth',
    });
  });
});

// Foursixty add to cart callback
window.onFoursixtyCartUpdated = () => {
  Cart.refresh();
};

// GLOBAL CUSTOM ELEMENTS

// Accordion Dropdown - CONVERT ALL TO <details> element
class AccordionGroup extends HTMLElement {

  constructor() {
    super();
    this.controls = this.querySelectorAll('button');
    this.controls.forEach(btn => btn.addEventListener('click', this.onControlClick.bind(this)));
  }

  onControlClick(event) {
    const target = event.target;
    target.classList.toggle('active');
    target.nextElementSibling.classList.toggle('!hidden');
    target.nextElementSibling.setAttribute('aria-expanded', !target.nextElementSibling.classList.contains('!hidden'));
  }
}
customElements.define('accordion-group', AccordionGroup);

// Quantity selector

class QuantityChange extends HTMLElement {

  constructor() {
    super();
    this.controls = this.querySelectorAll('[data-qty-change]');
    this.controls.forEach(btn => btn.addEventListener('click', this.onChange.bind(this)));
  }

  onChange(event) {
    const target = event.target;
    const change = event.target.dataset.qtyChange == 'plus' ? 'plus' : 'minus';
    const qtyInput = change == 'plus' ? target.previousElementSibling : target.nextElementSibling;
    if (change == 'minus' && target.dataset.cartMinus != undefined && qtyInput.value == 1) {
      const id = target.dataset.cartMinus;
      Cart.updateItem({
        id,
        quantity: 0
      });
    } else if (change == 'minus' && qtyInput.value == 1) {
      return false;
    }
    qtyInput.value = change == 'plus' ? ++qtyInput.value : --qtyInput.value;
    qtyInput.dispatchEvent(new Event('change'));
  }
}
customElements.define('quantity-selector', QuantityChange);

// Back in Stock

class BackInStockTrigger extends HTMLElement {

  constructor() {
    super();
    this.dialog = document.querySelector('[data-dialog="bis"]');
    this.dialogWrapper = this.dialog.querySelector('[data-dialog-wrapper="bis"]');
    this._backInStockToggleHandler();
  }

  _backInStockToggleHandler() {
    const hideBis = this._hideBisDialog.bind(this);
    const show = this._showBisDialog.bind(this);
    document.addEventListener('click', (event) => {
      const { target } = event;
      if (target.hasAttribute('data-bis-trigger')) {
        const bisInput = document.querySelector('[data-bis-input]');
        if (target.hasAttribute('data-bis-product')) {
          bisInput.setAttribute('data-variant', target.dataset.bisVariant);
          bisInput.setAttribute('data-product', target.dataset.bisProduct);
        }
        show('bis');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        hideBis();
      }
    });
  }

  _showBisDialog(name) {
    if (!name) {
      console.error('Missing "name" attribute for showDialog()');
    }
    this.dialog.className = `dialog active ${name}`;
    this.dialogWrapper.focus();
  }

  _hideBisDialog() {
    this.dialog.className = 'dialog';
  }
}
customElements.define('back-in-stock-trigger', BackInStockTrigger);

class BackInStockForm extends HTMLElement {

  constructor() {
    super();
    this.backInStockForm = this.querySelector('[data-bis-form]');
    this.backInStockMessage = this.querySelector('[data-bis-message]');
    this.dialog = this.closest('[data-dialog="bis"]');
    if (this.dialog) {
      this.dialogWrapper = this.dialog.querySelector('[data-dialog-wrapper="bis"]');
      this.dialogOverlay = this.dialog.querySelector('[data-dialog-overlay="bis"]');
      this.dialogCloseBtn = this.dialog.querySelector('[data-close-dialog="bis"]');
      this.closeButtons = [this.dialogOverlay, this.dialogCloseBtn];
      this.closeButtons.forEach((el) => el.addEventListener('click', () => this._hideBisDialog()));
    }
    this.backInStockForm.addEventListener('submit', this._bisFormSubmitHandler.bind(this));
  }

  _hideBisDialog() {
    this.dialog.className = 'dialog';
  }

  _bisFormSubmitHandler(event) {
    event.preventDefault();
    const form = event.target;
    const input = form.elements.bis_input;
    const emailAddress = input.value;
    const variantId = input.dataset.variant;
    const message = this.backInStockMessage;    
    const data = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              // id: '01GDDKASAP8TKDDA2GRZDSVP4H',
              attributes: {
                email: emailAddress
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.shop_api.vendor.klaviyo.publicApiKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-07-15',
        'accept': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      console.log('response',response);
      if (response.status === 202) {
        message.innerText = 'Thanks! Watch out for that email.';
      } else {
        message.innerText = 'Error subscribing to back in stock notification';
      }
      form.reset();
      setTimeout(function() {
        message.innerText = '';
      }, 5000);
      return response.text()
    })
    .then(response => console.log('text response',response))
    .catch(err => console.error(err));
  }
}
customElements.define('back-in-stock', BackInStockForm);

// Global Modal Trigger Button
class ModalTrigger extends HTMLElement {

  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    const dialogEntry = document.querySelector('[data-dialog-entry]');
    const content = shop_api.settings.globalPopupHeader != "" ? `<div class="dialog__header">${shop_api.settings.globalPopupHeader}</div>${shop_api.settings.globalPopupContent}` : shop_api.settings.globalPopupContent;
    dialogEntry.innerHTML = content;
    showDialog('global-popup');
  }
}
customElements.define('modal-trigger', ModalTrigger);

// Mobile Menu
class MobileMenu extends HTMLElement {

  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-toggle-menu]');
    this.overlay = this.querySelector('[data-close-menu]');
    this.menu = this.querySelector('nav');
    this.toggleButton.addEventListener('click', this.onButtonClick.bind(this));
    this.overlay.addEventListener('click', this.onOverlayClick.bind(this));
  }

  onButtonClick() {
    this.classList.add('active');
    this.menu.setAttribute('aria-expanded', this.classList.contains('active'));
  }

  onOverlayClick() {
    this.classList.remove('active');
    this.menu.setAttribute('aria-expanded', this.classList.contains('active'));
  }
}
customElements.define('mobile-menu', MobileMenu);

// Influence Points
class CustomerPoints extends HTMLElement {

  constructor() {
    super();
    this.getPoints();
  }

  getPoints() {
    const INFLUENCEIO_LAUNCHER_API_URL = "https://launcher.api.influence.io/launcher";
    const data = {
      shop: shop_api.shop.permanentDomain,
      customer_email: shop_api.customer.email,
      customer_id: shop_api.customer.id,
      digest: shop_api.vendor.influence.customerDigest,
    };
    fetch(INFLUENCEIO_LAUNCHER_API_URL + "/shopify/customer?" + new URLSearchParams(data))
      .then((response) => response.json())
      .then((data) => {
        console.log('INFLUENCE CUSTOMER POINTS', data);
        const { pointBalance } = data;
        const balanceFormatted = new Intl.NumberFormat('en-US').format(pointBalance);
        this.innerText = balanceFormatted;
        const pointContainer = this.closest('[data-account-points-container]');
        if (pointContainer) {
          pointContainer.style.display = 'unset';
        }
      })
  }
}
customElements.define('customer-points', CustomerPoints);

// Localization form flyout in footer
class LocalizationForm extends HTMLElement {

  constructor() {
    super();
    this.button = this.querySelector('[data-localization-button]');
    this.flyout = this.querySelector('[data-localization-flyout]');
    this.button.addEventListener('click', this.openLocalizationFlyout.bind(this));
    this.closeButtons = this.querySelectorAll('[data-close-localization]');
    this.closeButtons.forEach(button => button.addEventListener('click', this.closeLocalizationFlyout.bind(this)));
    this.currencyForm = this.querySelector('#localization_form');
  }

  openLocalizationFlyout() {
    this.flyout.setAttribute('open','');
  }

  closeLocalizationFlyout() {
    this.flyout.removeAttribute('open');
  }
  
}
customElements.define('localization-form', LocalizationForm);

class Newsletter extends HTMLElement {

  constructor() {
    super();
    this.form = this.querySelector('[data-email-form]');
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.formMessage = this.form.querySelector('[data-newsletter-message]');
  }

  onFormSubmit(event) {
    event.preventDefault();
    const form = this.form;
    const klaviyoListId = form.dataset.klaviyoList;
    const email = event.target.elements.email.value;
    const formName = form.dataset.emailForm || 'Footer Newsletter Signup';
    klaviyoSubscribe(
      klaviyoListId,
      email,
      formName,
      form.elements.$consent.checked,
      form.elements.$consent.value
    );
    this.formMessage.style.display = 'block';
    form.reset();
    const { customer } = shop_api;
    const advMatching = customer.loggedIn
      ? {
          ct: customer.city,
          country: customer.country,
          fn: customer.firstName,
          ln: customer.lastName,
          ph: customer.phone,
          st: customer.state,
          zp: customer.zip,
        }
      : {
          em: email,
        };
    setTimeout(function() {
      form.querySelector('[data-newsletter-message]').style.display = 'none';
    }, 5000);
    dataLayer.push({ event: 'newsletter-signup' });
    fbq('track', 'CompleteRegistration', advMatching);
  }
}
customElements.define('newsletter-form', Newsletter);

class KlaviyoSignup extends HTMLElement {

  constructor() {
    super();
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('[data-success]');
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    const email = event.target.elements.email.value;
    const klaviyoListId = event.target.dataset.klaviyoList;
    klaviyoSubscribe(klaviyoListId, email, 'Live Free Splash Page', null, null, null);
    this.successMessage.classList.remove('hidden');
    setTimeout(() => {
      this.successMessage.classList.add('hidden');
    }, 4000);
  }
  
}
customElements.define('klaviyo-signup', KlaviyoSignup);